// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateExpiredChecker_wrapper__2LBok","tooltip":"DateExpiredChecker_tooltip__1qx6E"};